import Drawable from '../entities/Drawable.js';
import TypeBadge from './TypeBadge.js';
import Sprite from './Sprite.js';
import { imageStore } from '../images.js';
import { KPI_P } from '../OverworldAnimation.js';
import PokemonSprite from './PokemonSprite.js';
import { c } from '../setup.js';
import PixelText from './PixelText.js';

export default class PokemonSummary extends Drawable {
    constructor({ pokemon, currentPage = 0, visible = false, position = { x: 0, y: 0 } }) {
        super();
        this.pokemon = pokemon;
        this.currentPage = currentPage;
        this.visible = visible;
        this.position = position;
        this.showMoveSummary = false;
        this.selectedMove = 0;
        this.pokemonSprite = new PokemonSprite({
            pokemon: pokemon,
            position: {
                x: 32,
                y: 32,
            },
        });

        this.navigationBarText = new PixelText({
            text: 'POKEMON INFO',
            position: { x: this.position.x + 8, y: this.position.y + 11 - 7 },
            color: 'white',
        });

        this.pokemonWindowLvText = new PixelText({
            text: '',
            position: { x: this.position.x + 8, y: this.position.y + 28 - 7 },
            color: 'white',
        });

        this.pokemonWindowNameText = new PixelText({
            text: '',
            position: { x: this.position.x + 40, y: this.position.y + 28 - 7 },
            color: 'white',
        });

        this.pokemonNumberText = new PixelText({
            text: '',
            position: { x: this.position.x + 168, y: this.position.y + 30 - 7 },
            color: 'black',
        });

        this.pokemonNameText = new PixelText({
            text: ``,
            position: {
                x: this.position.x + 168,
                y: this.position.y + 30 + 15 - 7,
            },
            color: 'black',
        });

        let genderString = '';
        let genderColor = 'black';
        if (this.pokemon?.gender === 'Female') {
            genderString = '  \u2640 ';
            genderColor = 'red';
        }
        if (this.pokemon?.gender === 'Male') {
            genderString = '  \u2642 ';
            genderColor = 'blue';
        }

        this.pokemonGenderText = new PixelText({
            text: genderString,
            position: {
                x: 110,
                y: this.pokemonWindowLvText.position.y,
            },
            color: genderColor,
            textAlign: 'right',
        });

        this.pokemonOriginalTrainerText = new PixelText({
            text: ``,
            position: {
                x: this.position.x + 168,
                y: this.position.y + 30 + 45 - 7,
            },
            color: 'black',
        });

        this.pokemonIDText = new PixelText({
            text: ``,
            position: {
                x: this.position.x + 168,
                y: this.position.y + 30 + 60 - 7,
            },
            color: 'black',
        });

        this.pokemonItemText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 168,
                y: this.position.y + 30 + 75 - 7,
            },
            color: 'black',
        });

        this.pokemonTypeBadge1 = new TypeBadge({
            type: null,
            position: {
                x: this.position.x + 168,
                y: this.position.y + 30 + 19,
            },
        });

        this.pokemonTypeBadge2 = new TypeBadge({
            type: null,
            position: {
                x: this.position.x + 168 + 40,
                y: this.position.y + 30 + 19,
            },
        });

        this.trainerMemoNatureText = new PixelText({
            text: '',
            position: { x: this.position.x + 8, y: this.position.y + 122 - 7 },
            color: 'black',
        });

        this.hpEVText = new PixelText({
            text: '',
            position: { x: this.position.x + 185, y: this.position.y + 35 - 7 },
            color: 'black',
            textAlign: 'right',
        });

        this.attackEVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185,
                y: this.position.y + 35 + 13 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.defenseEVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185,
                y: this.position.y + 35 + 26 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.specialAttackEVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185,
                y: this.position.y + 35 + 39 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.specialDefenseEVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185,
                y: this.position.y + 35 + 52 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.speedEVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185,
                y: this.position.y + 35 + 65 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.hpIVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185 + 22,
                y: this.position.y + 35 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.attackIVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185 + 22,
                y: this.position.y + 35 + 13 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.defenseIVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185 + 22,
                y: this.position.y + 35 + 26 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.specialAttackIVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185 + 22,
                y: this.position.y + 35 + 39 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.specialDefenseIVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185 + 22,
                y: this.position.y + 35 + 52 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });
        this.speedIVText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 185 + 22,
                y: this.position.y + 35 + 65 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.hpStatText = new PixelText({
            text: '',
            position: { x: this.position.x + 240 - 8, y: this.position.y + 35 - 7 },
            color: 'black',
            textAlign: 'right',
        });

        this.attackStatText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 13 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.defenseStatText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 26 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.specialAttackStatText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 39 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.specialDefenseStatText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 52 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.speedStatText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 65 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.currentExperienceLabelText = new PixelText({
            text: 'EXP. POINTS',
            position: { x: this.position.x + 72, y: this.position.y + 35 + 78 - 7 },
            color: 'black',
            textAlign: 'left',
        });

        this.nextLevelExperienceLabelText = new PixelText({
            text: 'NEXT LV.',
            position: {
                x: this.position.x + 72,
                y: this.position.y + 35 + 78 + 13 - 7,
            },
            color: 'black',
            textAlign: 'left',
        });

        this.currentExperienceText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 78 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.nextLevelExperienceText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 35 + 78 + 13 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.abilityText = new PixelText({
            text: 'POTENTIAL',
            position: {
                x: this.position.x + 72,
                y: this.position.y + 35 + 78 + 26 - 7,
            },
            color: 'black',
            textAlign: 'left',
        });

        this.abilityDescriptionText = new PixelText({
            text: 'Nothing happens until the dev implements abilities',
            position: {
                x: this.position.x + 10,
                y: this.position.y + 35 + 78 + 38 - 7,
            },
            color: 'black',
            textAlign: 'left',
            maxWidth: 200,
        });

        this.sprites = {
            background: new Sprite({
                position: { x: 0, y: 0 },
                image: imageStore.get('img/summary_menu.png'),
                visible: false,
                frames: { max: 4, val: 0 },
                moving: false,
            }),

            currentPokemon: null,

            pokeball: new Sprite({
                position: { x: 100, y: 80 },
                image: imageStore.get('img/pokeballs.png'),
                visible: false,
                frames: { max: 13, val: 0 },
                moving: false,
            }),

            currentPokemonIcon: null,

            selectedMoveBox: new Sprite({
                position: { x: 0, y: 0 },
                image: imageStore.get('img/selected_move_box.png'),
                visible: false,
                frames: { max: 1, val: 0 },
                moving: false,
            }),
        };

        this.move0Text = new PixelText({
            text: '',
            position: { x: this.position.x + 240 - 8, y: this.position.y + 32 - 7 },
            color: 'black',
            textAlign: 'right',
        });

        this.move0PPText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 9 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move1Text = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 28 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move1PPText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 37 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move2Text = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 56 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move2PPText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 65 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move3Text = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 84 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move3PPText = new PixelText({
            text: '',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 93 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move0TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 9,
            },
            type: 'blank',
        });

        this.move1TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 37,
            },
            type: 'blank',
        });

        this.move2TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 65,
            },
            type: 'blank',
        });

        this.move3TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 93,
            },
            type: 'blank',
        });

        this.cancelText = new PixelText({
            text: 'CANCEL',
            position: { x: 200, y: this.position.y + 148 - 7 },
            textAlign: 'right',
            color: 'black',
        });

        this.movePowerText = new PixelText({
            text: '--',
            position: { x: this.position.x + 59, y: this.position.y + 67 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.moveAccuracyText = new PixelText({
            text: '--',
            position: { x: this.position.x + 59, y: this.position.y + 67 + 14 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.moveDescriptionText = new PixelText({
            text: '',
            maxWidth: 100,
            position: { x: this.position.x + 8, y: this.position.y + 108 - 7 },
            textAlign: 'left',
            color: 'black',
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }

        if (KPI_P) {
            console.log(this);
        }

        if (this.pokemon === null || this.pokemon === undefined) {
            return;
        }
        this.navigationBarText.text = {
            0: 'POKEMON INFO',
            1: 'POKEMON SKILLS',
            2: 'KNOWN MOVES',
            3: 'KNOWN MOVES',
        }[this.currentPage];
        this.pokemonSprite.pokemon = this.pokemon;
        this.sprites.background.visible = this.visible;
        this.sprites.background.draw();
        this.navigationBarText.draw();
        this.pokemonWindowNameText.text = this.pokemon.name;
        this.pokemonWindowNameText.draw();

        let genderString = '';
        if (this.pokemon?.gender === 'Female') {
            genderString = '  \u2640 ';
            this.pokemonGenderText.color = PixelText.redTextColor;
            this.pokemonGenderText.shadowColor = PixelText.blackShadowColor;
        }
        if (this.pokemon?.gender === 'Male') {
            genderString = '  \u2642 ';
            this.pokemonGenderText.color = PixelText.blueTextColor;
            this.pokemonGenderText.shadowColor = PixelText.blackShadowColor;
        }
        this.pokemonGenderText.text = genderString;
        // this.pokemonGenderText.color = genderColor;

        if (this.showMoveSummary) {
            this.sprites.background.frames.val = 3;
            this.move0Text.text = this.pokemon.moves[0]?.name || '--';
            this.move0PPText.text = `PP ${this.pokemon.moves[0]?.pp || '--'}/${
                this.pokemon.moves[0]?.maxPP || '--'
            }`;
            this.move1Text.text = this.pokemon.moves[1]?.name || '--';
            this.move1PPText.text = `PP ${this.pokemon.moves[1]?.pp || '--'}/${
                this.pokemon.moves[1]?.maxPP || '--'
            }`;
            this.move2Text.text = this.pokemon.moves[2]?.name || '--';
            this.move2PPText.text = `PP ${this.pokemon.moves[2]?.pp || '--'}/${
                this.pokemon.moves[2]?.maxPP || '--'
            }`;
            this.move3Text.text = this.pokemon.moves[3]?.name || '--';
            this.move3PPText.text = `PP ${this.pokemon.moves[3]?.pp || '--'}/${
                this.pokemon.moves[3]?.maxPP || '--'
            }`;

            const movePower = this.pokemon.moves[this.selectedMove]?.power;
            const moveAccuracy = this.pokemon.moves[this.selectedMove]?.accuracy;
            this.movePowerText.text = movePower > 0 ? String(movePower) : '--';
            if (this.movePowerText.text.length === 3) {
                this.movePowerText.position.x = this.position.x + 59;
            } else {
                this.movePowerText.position.x = this.position.x + 61;
            }
            this.movePowerText.draw();
            this.moveAccuracyText.text = moveAccuracy > 0 ? String(moveAccuracy) : '--';
            if (this.moveAccuracyText.text.length === 3) {
                this.moveAccuracyText.position.x = this.position.x + 59;
            } else {
                this.moveAccuracyText.position.x = this.position.x + 61;
            }
            this.moveAccuracyText.draw();

            this.moveDescriptionText.text = this.pokemon.moves[this.selectedMove]?.effect || '';
            this.moveDescriptionText.draw();

            this.move0TypeBadge.type = this.pokemon.moves[0]?.type || 'blank';
            this.move0TypeBadge.draw();
            this.move1TypeBadge.type = this.pokemon.moves[1]?.type || 'blank';
            this.move1TypeBadge.draw();
            this.move2TypeBadge.type = this.pokemon.moves[2]?.type || 'blank';
            this.move2TypeBadge.draw();
            this.move3TypeBadge.type = this.pokemon.moves[3]?.type || 'blank';
            this.move3TypeBadge.draw();

            this.move0Text.draw();
            this.move0PPText.draw();
            this.move1Text.draw();
            this.move1PPText.draw();
            this.move2Text.draw();
            this.move2PPText.draw();
            this.move3Text.draw();
            this.move3PPText.draw();

            this.sprites.currentPokemonIcon = this.pokemon.icon;
            this.sprites.currentPokemonIcon.position = { x: 0, y: 16 };
            this.sprites.currentPokemonIcon.visible = true;
            this.sprites.currentPokemonIcon.spriteIndex = this.pokemon.id - 1;
            this.sprites.currentPokemonIcon.draw();

            this.sprites.selectedMoveBox.visible = true;
            this.sprites.selectedMoveBox.position = {
                x: 128,
                y: 22 + 28 * this.selectedMove,
            };
            this.sprites.selectedMoveBox.draw();

            this.cancelText.draw();
            this.pokemonGenderText.draw();

            return;
        } else {
            this.pokemonSprite.pokemon = this.pokemon;
            this.pokemonSprite.draw();
            this.sprites.pokeball.visible = this.visible;
            switch (this.pokemon.pokeball.id) {
                case 'pokeball':
                    this.sprites.pokeball.frames.val = 0;
                    break;
                case 'great_ball':
                    this.sprites.pokeball.frames.val = 1;
                    break;
                case 'ultra_ball':
                    this.sprites.pokeball.frames.val = 2;
                    break;
                case 'master_ball':
                    this.sprites.pokeball.frames.val = 3;
                    break;
            }
            this.sprites.pokeball.draw();
            this.pokemonWindowLvText.text = `Lv${this.pokemon.level}`;
            this.pokemonWindowLvText.draw();
            this.pokemonGenderText.draw();
        }
        switch (this.currentPage) {
            case 0:
                this.sprites.background.frames.val = 0;
                this.pokemonNumberText.text = `${this.pokemon.id}`.padStart(3, '0');
                this.pokemonNumberText.draw();
                this.pokemonNameText.text = this.pokemon.name;
                this.pokemonNameText.draw();
                this.pokemonTypeBadge1.type = this.pokemon.type1;
                this.pokemonTypeBadge1.draw();
                this.pokemonTypeBadge2.type = this.pokemon.type2;
                if (!!this.pokemon.type2 && this.pokemon.type1.id !== this.pokemon.type2.id) {
                    this.pokemonTypeBadge2.draw();
                }
                this.pokemonOriginalTrainerText.text = this.pokemon.originalTrainer.name;
                this.pokemonOriginalTrainerText.draw();
                this.pokemonIDText.text = this.pokemon.originalTrainer.id;
                this.pokemonIDText.draw();
                this.pokemonItemText.text = this.pokemon.item ? this.pokemon.item.name : 'None';
                this.pokemonItemText.draw();
                this.trainerMemoNatureText.text = this.pokemon.nature.summaryString();
                this.trainerMemoNatureText.draw();
                break;
            case 1: {
                this.sprites.background.frames.val = 1;
                this.hpEVText.text = `${this.pokemon.ev.hp}`.padStart(3, '0');
                this.hpEVText.draw();
                this.attackEVText.text = `${this.pokemon.ev.attack}`.padStart(3, '0');
                this.attackEVText.draw();
                this.defenseEVText.text = `${this.pokemon.ev.defense}`.padStart(3, '0');
                this.defenseEVText.draw();
                this.specialAttackEVText.text = `${this.pokemon.ev.specialAttack}`.padStart(3, '0');
                this.specialAttackEVText.draw();
                this.specialDefenseEVText.text = `${this.pokemon.ev.specialDefense}`.padStart(3, '0');
                this.specialDefenseEVText.draw();
                this.speedEVText.text = `${this.pokemon.ev.speed}`.padStart(3, '0');
                this.speedEVText.draw();

                this.hpIVText.text = `${this.pokemon.iv.hp}`.padStart(2, '0');
                this.hpIVText.draw();
                this.attackIVText.text = `${this.pokemon.iv.attack}`.padStart(2, '0');
                this.attackIVText.draw();
                this.defenseIVText.text = `${this.pokemon.iv.defense}`.padStart(2, '0');
                this.defenseIVText.draw();
                this.specialAttackIVText.text = `${this.pokemon.iv.specialAttack}`.padStart(2, '0');
                this.specialAttackIVText.draw();
                this.specialDefenseIVText.text = `${this.pokemon.iv.specialDefense}`.padStart(2, '0');
                this.specialDefenseIVText.draw();
                this.speedIVText.text = `${this.pokemon.iv.speed}`.padStart(2, '0');
                this.speedIVText.draw();

                this.hpStatText.text = `${this.pokemon.stats.maxHp}`;
                this.hpStatText.draw();
                this.attackStatText.text = `${this.pokemon.stats.attack}`;
                this.attackStatText.draw();
                this.defenseStatText.text = `${this.pokemon.stats.defense}`;
                this.defenseStatText.draw();
                this.specialAttackStatText.text = `${this.pokemon.stats.specialAttack}`;
                this.specialAttackStatText.draw();
                this.specialDefenseStatText.text = `${this.pokemon.stats.specialDefense}`;
                this.specialDefenseStatText.draw();
                this.speedStatText.text = `${this.pokemon.stats.speed}`;
                this.speedStatText.draw();

                this.currentExperienceLabelText.draw();
                this.nextLevelExperienceLabelText.draw();
                this.currentExperienceText.text = `${this.pokemon.experience}`;
                this.currentExperienceText.draw();
                this.nextLevelExperienceText.text = `${
                    this.pokemon.getNextLevelExperience() - this.pokemon.experience
                }`;
                this.nextLevelExperienceText.draw();

                // Update ability text
                if (this.pokemon.ability) {
                    this.abilityText.text = this.pokemon.ability.name.toUpperCase();
                    this.abilityDescriptionText.text =
                        this.pokemon.ability.description || 'This pokemon does not have an ability yet.';
                } else {
                    this.abilityText.text = 'POTENTIAL';
                    this.abilityDescriptionText.text = 'This pokemon does not have an ability yet.';
                }
                this.abilityText.draw();
                this.abilityDescriptionText.draw();

                c.fillStyle = Drawable.blueBarColor;
                const currentLevelExperience = this.pokemon.getCurrentLevelExperience();
                const nextLevelExperience = this.pokemon.getNextLevelExperience();
                const experienceBarProgress =
                    ((this.pokemon.experience - currentLevelExperience) /
                        (nextLevelExperience - currentLevelExperience)) *
                    64;

                c.fillRect(411 - 240, 132, experienceBarProgress, 3);

                break;
            }
            case 2:
                this.sprites.background.frames.val = 2;
                this.move0Text.text = this.pokemon.moves[0]?.name || '--';
                this.move0PPText.text = `PP ${this.pokemon.moves[0]?.pp || '--'}/${
                    this.pokemon.moves[0]?.maxPP || '--'
                }`;
                this.move1Text.text = this.pokemon.moves[1]?.name || '--';
                this.move1PPText.text = `PP ${this.pokemon.moves[1]?.pp || '--'}/${
                    this.pokemon.moves[1]?.maxPP || '--'
                }`;
                this.move2Text.text = this.pokemon.moves[2]?.name || '--';
                this.move2PPText.text = `PP ${this.pokemon.moves[2]?.pp || '--'}/${
                    this.pokemon.moves[2]?.maxPP || '--'
                }`;
                this.move3Text.text = this.pokemon.moves[3]?.name || '--';
                this.move3PPText.text = `PP ${this.pokemon.moves[3]?.pp || '--'}/${
                    this.pokemon.moves[3]?.maxPP || '--'
                }`;

                this.move0TypeBadge.type = this.pokemon.moves[0]?.type || 'blank';
                this.move0TypeBadge.draw();
                this.move1TypeBadge.type = this.pokemon.moves[1]?.type || 'blank';
                this.move1TypeBadge.draw();
                this.move2TypeBadge.type = this.pokemon.moves[2]?.type || 'blank';
                this.move2TypeBadge.draw();
                this.move3TypeBadge.type = this.pokemon.moves[3]?.type || 'blank';
                this.move3TypeBadge.draw();

                this.move0Text.draw();
                this.move0PPText.draw();
                this.move1Text.draw();
                this.move1PPText.draw();
                this.move2Text.draw();
                this.move2PPText.draw();
                this.move3Text.draw();
                this.move3PPText.draw();
                break;
        }
    }
}
